// @noflow
import type { Theme } from '../../common/themes/types';
import colors from '../../common/themes/colors';
import typography from '../../common/themes/typography';

export const fontFamily = [
  '"Proxima Nova"',
  'Roboto',
  'system-ui',
  'BlinkMacSystemFont',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
].join(', ');

const themeColors = {
  background: colors.darkGrey,
  primary: colors.white,
  header: colors.white,
  highlight: colors.sunflower,
  success: colors.green,
  warning: colors.honey,
  danger: colors.dishRed,
  error: colors.dishRed,
  gray: colors.battleship,
  open: colors.white,
  text: colors.white,
  link: colors.sunflower,

  // component colors
  hover: colors.dishRed,
  dropdown: colors.grey,
  dropdownHover: colors.dropdownHover,

  // new dish colors
  white: colors.white,
  primaryWhite: colors.primaryWhite,
  black: colors.black,
  amethyst: colors.amethyst,
  azure: colors.azure,
  battleship: colors.battleship,
  emerald: colors.emerald,
  frenchRose: colors.frenchRose,
  honey: colors.honey,
  onyx: colors.onyx,
  progressBar: colors.progressBar,
  royalBlue: colors.royalBlue,
  silver: colors.silver,
  sunflower: colors.sunflower,
  teal: colors.teal,

  // newest dany colors
  veryDarkGrey: colors.veryDarkGrey,
  darkGrey: colors.darkGrey,
  mediumGrey: colors.mediumGrey,
  grey: colors.grey,

  dishRed: colors.dishRed,
  blue: colors.blue,
  lightGreen: colors.lightGreen,
  green: colors.green,

  veryLightGrey: colors.veryLightGrey,
  lightGrey: colors.lightGrey,
  mobileTitle: colors.dishRed,

  kidsBlue: colors.kidsBlue,
};

const theme: Theme = {
  typography: typography({
    fontSize: 16,
    fontSizeScale: 'step5',
    lineHeight: 20,
  }),
  colors: themeColors,
  states: {
    active: {
      darken: 0.2,
      opacity: 0.7,
    },
    disabled: {
      opacity: 0.5,
    },
  },
  container: {
    maxWidths: {
      small: 540,
      medium: 720,
      big: 960,
      bigger: 1660,
      biggest: 1920,
    },
  },
  pageContainer: {
    backgroundColor: themeColors.background,
    width: '100%',
    padding: '30px 30px 10px 30px',
    '@media (max-width: 800px)': {
      padding: '0 15px 10px 15px',
    },
  },
  modals: {
    title: {
      fontSize: 20,
    },
    fixedContainer: {
      bottom: 0,
      height: '100%',
      left: 0,
      overflow: 'hidden',
      position: 'absolute',
      right: 0,
      top: 0,
      width: '100%',
      zIndex: 9,
    },
    content: {
      backgroundColor: colors.mediumGrey,
      bottom: 0,
      display: 'flex',
      overflowY: 'auto',
      padding: 30,
      position: 'fixed',
      right: 0,
      top: 0,
      width: 400,
    },
  },
  text: {
    bold: 600,
    fontFamily,
    textShadow: '1px 1px 3px rgba(123,123,123,0.8)',
  },
  textOverflow: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  block: {
    marginBottom: 1,
    maxWidth: 46,
  },
  button: {
    borderRadius: 2,
  },
  heading: {
    fontFamily,
    marginBottom: 1,
    fontSize: 18,
  },
  paragraph: {
    marginBottom: 1,
  },
  carousels: {
    container: {
      position: 'relative',
    },
    title: {
      fontSize: 24,
      marginTop: 40,
      marginBottom: 8,
    },
    navButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      boxShadow: '0 2px 2px -1px rgba(0,0,0,0.4), 0 2px 6px 0 rgba(0,0,0,0.36)',
      color: colors.white,
      backgroundColor: colors.grey,
      borderStyle: 'none',
      borderRadius: '50%',
      height: 48,
      width: 48,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 4,
    },
  },
};

export default theme;
